import { CustomFieldsResponses } from 'features/CustomFieldsResponses';
import { PunchupCustomFieldsResponses } from 'features/PunchupPages/CustomFieldsResponse';
import { PunchupCustomFieldsResponses as LegacyPunchupCustomFieldsResponses } from 'features/CustomFieldsResponses/PunchupCustomFieldsResponse';
import { useAppSelector } from 'store/hooks';

const AttendeesListPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupCustomFieldsResponses isAttendeesList={true} />;
	if (isPunchup) return <LegacyPunchupCustomFieldsResponses isAttendeesList={true} />;
	return <CustomFieldsResponses isAttendeesList={true} />;
};
export default AttendeesListPage;
